import moment from 'moment';
import router from '@/router'

export default {
    install: (app, options) => {
        const modal = (key, val) => {
            switch (key) {
                case "show":
                    document.getElementById(val).classList.add("show");
                    break;
                case "hide":
                    document.getElementById(val).classList.remove("show");
                    break;
            }
        }

        app.config.globalProperties.$modal = modal;
        app.provide('$modal', modal);
        app.config.globalProperties.$NODE_ENV = process.env.NODE_ENV;
        app.config.globalProperties.$VUE_APP_WS_URL = process.env.VUE_APP_WS_URL;
        app.config.globalProperties.$COLORS = {
            'negative': '#FF3B30',
            'positive_manual_start': '#1974d2',
            'positive_manual_new': '#1974d2',
            'positive': '#228b22',
            'positive_soft': '#84cc16',
            'yellow': '#eab308',
            'orange': '#f97316',
            'irrelevant': '#808080',
            'our': '#9900FF',
            'empty': '#3d3737',
        };

        app.config.globalProperties.$TAGS = [
            "#FF1744", // Красный (чистый спектр)
            "#F50057", // Розово-красный
            "#D500F9", // Фиолетовый (электрик)
            "#651FFF", // Темно-фиолетовый
            "#3D5AFE", // Индиго
            "#2979FF", // Синий
            "#00B0FF", // Голубой
            "#00E5FF", // Бирюзовый
            "#1DE9B6", // Мятный (неон)
            "#00E676", // Зеленый (неон)
            "#76FF03", // Салатовый (лайм)
            "#FFC400", // Янтарный
            "#FF9100", // Оранжевый
            "#FF3D00", // Красно-оранжевый (сигнальный)
            "#B388FF", // Светло-фиолетовый
            "#FF9E80", // Светло-лососевый
            "#FF6E40", // Ярко-коралловый
            "#FF3B30", // Красный (iOS)
            "#5856D6", // Фиолетово-синий
            "#007AFF", // Синий (iOS)
            "#34C759", // Зеленый (iOS)
            "#FF9500", // Оранжевый (iOS)
            "#FF2D55", // Розовый (iOS)
            "#AF52DE", // Пурпурный (iOS)
            "#FFCC00", // Желтый (iOS)
            "#8E8E93",  // Серый (для текста)
            "#FF0055", // Ярко-розовый (фуксия)
            "#00FF99", // Неоновая мята
            "#9900FF", // Фиолетово-синий
            "#FF6600", // Оранжевый (апельсин)
            "#0066FF", // Насыщенный синий
            "#FF00AA", // Горячий розовый
            "#AAFF00", // Яблочно-зеленый
            "#00AAFF", // Яркий лазурный
            "#FF2200", // Красный (сигнальный)
            "#FF44CC", // Светло-розовый неон
            "#44FF88", // Мятно-зеленый
            "#8844FF", // Фиолетово-индиго
            "#FF8844", // Персиково-оранжевый
            "#4488FF", // Васильковый
            "#FF0044", // Малиновый
            "#44FF00", // Зеленый (лазер)
            "#0044FF", // Синий (электрик)
            "#FF44AA", // Розово-красный
            "#AA44FF", // Пурпурный
            "#44FFAA", // Морская волна
            "#FFAA44", // Янтарный
            "#AAFF44", // Лимонно-лаймовый
            "#44AAFF", // Небесно-голубой
            "#FF44FF", // Ярко-розовый электрик
            "#44FF44", // Неоново-зеленый
            "#4444FF", // Синий (кобальт)
            "#FF4444", // Томатный
            "#FF44BB"  // Темно-розовый
        ];
        app.config.globalProperties.$TONES = [
            {
                id: "negative",
                name: "Негативные",
                param: "negatives",
                check: true,
                bcolor: "#FF3B30",
                color: "#FF3B3033"
            },
            {
                id: "positive",
                check: true,
                param: "positives",
                name: "Позитивные",
                color: "#59DDAA33",
                bcolor: "#59DDAA"
            }
        ];
        app.config.globalProperties.$ANSWERS = [
            {
                id: "yes",
                name: "С ответом",
            },
            {
                id: "no",
                name: "Без ответа",
            }
        ];
        app.config.globalProperties.$RATING = [
            {
                id: 0,
                name: "0",
            },
            {
                id: 1,
                name: "1",
            },
            {
                id: 2,
                name: "2",
            },
            {
                id: 3,
                name: "3",
            },
            {
                id: 4,
                name: "4",
            },
            {
                id: 5,
                name: "5",
            }
        ];

        app.config.globalProperties.$date_moment = (date, format) => {
            return moment(date).format(format);
        }
        app.config.globalProperties.$getTones = (type) => app.config.globalProperties.$TONES;
        app.config.globalProperties.$getTypes = (tone) => tone ? app.config.globalProperties.$TONES[tone].type_tones : {};
        app.config.globalProperties.$sizeInMb = (value) => {
            let sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
            value = parseInt(value)
            if (!value) return '0 B';
            let i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
            if (i) return Math.round(value / Math.pow(1024, i), 2) + ' ' + sizes[i];
            return "-"
        };
        app.config.globalProperties.$Declension = (count, titles) => {
            const cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        };
        app.config.globalProperties.$getShortName = (text) => {
            if (text) return text.slice(0, 2).toUpperCase()
            else return text
        };
        app.config.globalProperties.$pluralise = (number, words, includeNumber = true) => {
            const n = Math.abs(number);
            const n10 = n % 10;
            const n100 = n % 100;

            let word;
            if (n10 === 1 && n100 !== 11) word = words[0];
            else if (n10 >= 2 && n10 <= 4 && (n100 < 10 || n100 >= 20)) word = words[1];
            else word = words[2];

            return includeNumber ? `${number} ${word}` : word;
        };
        app.config.globalProperties.$compare_period = (date_from, date_to) => {
            const original = moment(date_from, 'YYYY-MM-DD');
            const end_compare = original.clone().subtract(1, 'days');
            const duration_days = moment(date_to).diff(moment(date_from), 'days');
            const start_compare = end_compare.clone().subtract(duration_days, 'days');
            return `${start_compare.format("DD.MM.YYYY")}-${end_compare.format("DD.MM.YYYY")}`
        };
        app.config.globalProperties.$widthratio = (count, total) => {
            return total ? Math.round((count / total) * 100) : 0;
        };
        app.config.globalProperties.$func = {

            momentDate: (date, format = "YYYY-MM-DD", default_type = false) => {
                try {
                    if (default_type) return moment(date, default_type).format(format)
                    return moment(date).format(format)
                } catch (e) {
                    return date
                }
            },
            historyBack: (path) => {
                if (!document.referrer || document.referrer === window.location.href) router.push(path);
                else router.go(-1)
            },
            getPagerArray: (all_count, size, page) => {
                let page_count = Math.ceil(all_count / size);
                let pages = Array.from({length: page_count}, (_, i) => i + 1);
                let array = [];
                if (page > 5) {
                    array = array.concat(pages.slice(0, page - 3 > 3 ? 3 : page - 3));
                    array.push('...')
                }
                array = array.concat(pages.slice(page - 4 > 0 ? page - 4 : 0, page + 3));
                if (page < (pages.length - 5)) {
                    array.push('...');
                    array = array.concat(pages.slice(pages.length - 3, pages.length));
                }
                return array;
            },
            createSearchParams: (params) => {
                const searchParams = new URLSearchParams();
                Object.entries(params).forEach(([key, values]) => {
                    if (Array.isArray(values)) {
                        values.forEach((value) => {
                            searchParams.append(key, value);
                        });
                    } else {
                        searchParams.append(key, values);
                    }
                });
                return searchParams;
            },
            dateString: (date) => {
                try {
                    return ('0' + date.getDate()).slice(-2) + '/'
                        + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
                        + date.getFullYear();
                } catch (e) {
                    return date
                }
            },
            getClass: function (link, made = true) {
                let COLORS = app.config.globalProperties.$COLORS;
                let val = made ? `${link.tone}_${link.kind_type}_${link.type_tone}` : link;
                return `color: ${COLORS[val] !== undefined ? COLORS[val] : '#000000'}`;
            },
            getTrustClass: function (resource) {
                if (resource && resource.trust === -1) {
                    return "negative";
                }
            },
            isMobile() {
                if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },
            isURL(url) {
                try {
                    return new URL(url)
                } catch (err) {
                    return false
                }
            },
            getDomain(url) {
                try {
                    let uri = new URL(url)
                    return uri.origin
                } catch (err) {
                    return url
                }
            }
        };

    },

}